<template>
  <div class="achievement">
    <div class="box"
         v-if="list.length>0">
      <div class="title">
        <span>《医疗器械行业协会注册助理专业能力水平考试 助理专业能力水平考试》</span>
      </div>
      <div class="list">
        <div class="item"
             v-for="(item,index) in list"
             :key="index"
             v-show="index == currentQuestion">
          <div class="item-title">
            <span class="indexNum">{{item.qOrder}} |</span>
            <span class="totlNum">{{list.length}}</span>
            <span class="type"
                  :class="{multselect: item.qType == 1}">{{item.qType==1?"多选题":"单选"}}</span>
            <span>{{item.qTitle}}</span>
          </div>
          <div class="item-comtent"
               @click="checkAn(item,el,index)"
               v-for="el in item.options"
               :key="el.oId">
            <i class="sele"
               :class="item.hwAnswer.indexOf(el.oId) > -1?'activeTab':''">
              <i></i>
            </i>
            <!-- <span>A.</span> -->
            <span>{{el.oTitle}}</span>
          </div>
          <div class="item-bottom"
               v-if="routerQuery == 'ccreslut'">
            <div class="item-bottomC">
              <span class="item-bottomLet">正确答案：</span>
              <span class="item-bottomRigt colorRed"
                    v-for="el in item.options"
                    :key="el.oId">{{el.oId== item.qOid?el.oTitle.substr(0,1):''}}</span>
            </div>
            <div class="item-bottomC">
              <span class="item-bottomLet">答案解析：</span>
              <span class="item-bottomRigt">{{item.qParse}}</span>
            </div>
          </div>
        </div>
      </div>

      <div class="next"
           v-if="list.length > 1 && currentQuestion < list.length "
           @click="currentQuestion++">
        <span>下一题</span>
      </div>
      <div class="next"
           @click="nextBnt()">
        <!-- <span>领取证书</span> -->
        <span>提交</span>
      </div>
    </div>
    <div class="noData"
         v-else>
      <img src="../../assets/images/nothing.png"
           alt />
      <span>暂无数据</span>
    </div>
    <div class="popBox"
         v-show="popV">
      <div class="wrap">
        <i class="close"
           @click="popV=false"></i>
        <div class="wrap-header">
          <span class="kaoshi1"></span>
        </div>
        <div class="wrap-content">
          <span>这里显示的是考试说明的内容，根据后台管理中编辑的内容展示。这里显示的是考试说明的内容，根据后台管理中编辑的内容展示。这里显示的</span>
        </div>
        <div class="wrap-header">
          <span class="kaoshi2"></span>
        </div>
        <div>
          <div class="list-title">
            <span>考试之前，您需学习完以下课程：</span>
          </div>
          <ul>
            <li class="item">
              Lvis密网支架辅助栓塞颅内宽颈动脉…
              <span class="itemBnt">去学习</span>
            </li>
            <li class="item">
              Lvis密网支架辅助栓塞颅内宽颈动脉…
              <span class="itemBnt">去学习</span>
            </li>
            <li class="item">
              Lvis密网支架辅助栓塞颅内宽颈动脉…
              <span class="itemBnt">去学习</span>
            </li>
            <li class="item">
              Lvis密网支架辅助栓塞颅内宽颈动脉…
              <span class="itemBnt">去学习</span>
            </li>
          </ul>
        </div>
        <div class="sure">
          <span>确定</span>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import iVideolist from "../container/videoList";
import loginService from "../../plugin/extendFn/loginService";
import AppSetting from '../../AppSetting';
export default {
  data () {
    return {
      activeTab: 1,
      currentQuestion: 1,
      itemId: 1,
      wxuser: null,
      popV: true,
      type: "1", //1视频（暂写死1），3会议
      id: "27",
      list: [],
      routerQuery: ""
    };
  },
  props: {},
  async mounted () {
    this.wxuser=await loginService.getLoginUser();

    document.title = "考试";
    // this.$postHttp(AppSetting.baseUrl + '/student/complete/video',{uid:this.wxuser.uId,}).then((res)=>{
    //   if(res.data.code==0){
    //     this.video_hottest = res.data.list;
    //   }
    // })
    //   this.getList()
    this.routerQuery = this.$route.query.type;
    this.type = 1;
    this.id = this.$route.query.id;
    this.popV = false;
    if (this.$route.query.type == "video") {
      this.getList();
    } else if (this.$route.query.type == "ccreslut") {
      this.getuserInfo();
    }
  },
  methods: {
    nextBnt (val) {
      this.addVquestion();
      // this.getList()
    },
    checkAn (item, el, index) {
      if (!item.hwAnswer) {
        item.hwAnswer = [];
      }
      if (item.qType == 0) {
        item.hwAnswer[0] = el.oId;
      } else {
        item.hwAnswer.push(el.oId);
      }
      // vm.$set(vm.items, indexOfItem, newValue)
      this.$set(this.list, index, item);
    },
    tab (val) {
      this.activeTab = val;
      this.getList();
    },
    getList () {
      
      this.$postHttp(AppSetting.baseUrl + "/question/app/info", {
        type: this.type,
        id: this.id
      }).then(res => {
        if (res.data.code == 0) {
          res.data.questions.map(item => {
            if (!item.hwAnswer) {
              item.hwAnswer = [];
            }
            return item;
          });
          this.list = res.data.questions;
          // this.certificateList = res.data.list;
        }
      });
    },
    getuserInfo () {
      this.$postHttp(AppSetting.baseUrl + "/question/app/userInfo", {
        type: this.type,
        id: this.id
      }).then(res => {
        if (res.data.code == 0) {
          this.list = res.data.questions;
          // this.certificateList = res.data.list;
        }
      });
    },
    getVideoList () {
      this.$postHttp(AppSetting.baseUrl + "/question/app/videoList", {
        uid: this.wxuser.uId
      }).then(res => {
        if (res.data.code == 0) {
          // this.certificateList = res.data.list;
        }
      });
    },

    addVquestion () {
      let works = [];
      this.list.map(item => {
        if (item.hwAnswer.length == 0) {
          this.toast("请完成答题");
          return;
        }
        let obj = {
          hwQId: item.qId,
          hwAnswer: item.hwAnswer.join(","),
          hwQOid: item.qOid
        };
        works.push(obj);
      });
      let param = {
        hwUId: this.wxuser.uId,
        hwVId: this.id,
        works: works
      };
      this.$postHttp(AppSetting.baseUrl + "/homework/app/add", param).then(res => {
        if (res.data.code == 0) {
          this.$router.push({
            name: "Ccreslut",
            query: { type: "answer", id: this.id }
          });
        } else {
          this.toast(res.data.msg);
        }
      });
    }
  }
};
</script>
<style scoped lang="scss">
.achievement {
  width: 100%;
  height: 100%;
  background: #f4f5f4;
  min-height: 100vh;
  .box {
    padding: 0.4rem 0.3rem;
    box-sizing: border-box;
    .title {
      font-size: 0.3rem;
      color: #333;
      margin-bottom: 0.46rem;
    }
    .list {
      font-size: 0.32rem;
      color: #333333;
      background: #fff;
      padding: 0.59rem 0.3rem;
      box-sizing: border-box;
      .indexNum {
        color: #05a2ff;
        font-weight: 800;
        font-size: 0.4rem;
      }
      .totlNum {
        color: #bababa;
        font-size: 0.4rem;
        font-weight: 800;
      }
      .type {
        font-size: 14px;
        color: #fff;
        background: #22ac38;
        padding: 2px 7px;
        border-radius: 0.05rem;
      }
      .multselect {
        font-size: 14px;
        color: #fff;
        background: #f39800;
        padding: 2px 7px;
        border-radius: 0.05rem;
      }
    }
    .item-comtent {
      font-size: 0.28rem;
      color: #333;
      margin-top: 0.3rem;
      margin-bottom: 0.3rem;

      .sele {
        display: inline-block;
        width: 0.3rem;
        height: 0.3rem;
        border-radius: 50%;
        border: 0.01rem solid #d2d2d2;
        position: relative;
        vertical-align: text-bottom;
      }
      .activeTab {
        i {
          display: inline-block;
          position: absolute;
          width: 0.2rem;
          height: 0.2rem;
          border-radius: 50%;
          box-sizing: border-box;
          background: #05a2ff;
          top: 0px;
          bottom: 0px;
          left: 0px;
          right: 0px;
          margin: auto;
        }

        border: 0.01rem solid #05a2ff;
      }
    }
    .item-bottom {
      font-size: 0.32rem;
      color: #333;
      border-bottom: 0.01rem solid #dcdcdc;
      // margin-top: 0.43rem;
      // padding-top: 0.43rem;
      padding-bottom: 0.4rem;
      margin-bottom: 0.4rem;

      .item-bottomC {
        overflow: hidden;
        margin-top: 0.15rem;
      }
      .item-bottomLet {
        float: left;
        width: 28%;
      }
      .item-bottomRigt {
        float: left;
        width: 72%;
        font-size: 0.28rem;
        color: #666;
      }
      .colorRed {
        color: red;
      }
    }
    .next {
      font-size: 0.36rem;
      color: #fff;
      background: #05a2ff;
      width: 2.85rem;
      line-height: 0.91rem;
      text-align: center;
      margin: auto;
      margin-top: 1rem;
      border-radius: 0.1rem;
    }
  }

  .tab {
    width: 100%;
    display: flex;
    font-size: 0.3rem;
    color: #333;
    text-align: center;
    line-height: 0.8rem;
    background: #fff;
    padding: 0px 0.3rem;
    box-sizing: border-box;
    span {
      flex: 1;
      padding: 0px 0.15rem;
      box-sizing: border-box;
    }
  }
  .activeTab {
    color: #05a2ff;
    font-size: 0.34rem;
    border-bottom: 0.01rem solid #05a2ff;
  }
  .search {
    padding: 0.33rem 0.29rem;
    box-sizing: border-box;
    overflow: hidden;
    .searchLet {
      float: left;
      width: 20%;
      font-size: 0.3rem;
      color: #333;
      line-height: 0.7rem;
    }
    .search_inp {
      float: left;
      height: 0.7rem;
      line-height: 0.7rem;
      width: 80%;
      position: relative;
      padding-right: 0.15rem;
      // border-radius: 0.15rem;
      box-sizing: border-box;
      // background:rgba(238,238,238,1);
      input {
        background: none;
        outline: none;
        border: none;
        display: inline-block;
        position: absolute;
        top: 0px;
        left: 0.3rem;
        width: 98%;
        height: 90%;
        outline: none;
        border-radius: 0.15rem;
        box-sizing: border-box;
        padding: 0 0.3rem;
        background: rgba(238, 238, 238, 1);
      }
      .searchBnt {
        width: 0.28rem;
        height: 0.28rem;
        position: absolute;
        right: 0.15rem;
        top: 50%;
        margin-top: -0.14rem;
        // background: url("../../assets/images/search.png");
        background-size: 100% 100%;
      }
    }
  }
  .carList {
    .item {
      padding-bottom: 0.12rem;
    }
    .item-title {
      font-size: 0.3rem;
      color: #333333;
      line-height: 1.04rem;
      background: #fff;
      padding: 0px 0.3rem;
      box-sizing: border-box;
      position: relative;
      // borde-bottom: 0.01rem solid #
      .bnt {
        font-size: 0.22rem;
        background: #05a2ff;
        color: #fff;
        border-radius: 0.1rem;
        padding: 0rem 0.05rem;
        height: 0.39rem;
        line-height: 0.39rem;
        position: absolute;
        top: 0px;
        bottom: 0px;
        margin: auto;
        right: 0.1rem;
      }
      .score {
        float: right;
        :first-child {
          font-size: 0.5rem;
          color: #ff0000;
        }
      }
    }
  }
  .popBox {
    position: absolute;
    width: 100%;
    height: 100%;
    top: 0px;
    left: 0px;
    background: rgba(0, 0, 0, 0.5);
    padding: 1.56rem 0.56rem 0px;
    box-sizing: border-box;

    .wrap {
      padding: 0.35rem 0px;
      width: 85%;
      border-radius: 0.15rem;
      margin: auto;
      background: #fff;
      font-size: 0.26rem;
      color: #535353;
      position: relative;
      .close {
        display: inline-block;
        width: 0.35rem;
        height: 0.35rem;
        background: url("../../assets/images/close.png") no-repeat;
        background-size: 100% 100%;
        position: absolute;
        right: 0.15rem;
        top: 0.15rem;
      }
      .wrap-header {
        font-size: 0.33rem;
        color: #05a2ff;
        text-align: center;
        padding: 0.35rem 0rem;
        span {
          display: inline-block;
          width: 2.56rem;
          height: 0.44rem;
          margin: auto;
        }
        .kaoshi1 {
          background: url("../../assets/images/kaoshishuoming.png") no-repeat;
          background-size: 100% 100%;
        }
        .kaoshi2 {
          background: url("../../assets/images/kaoshiqianti.png") no-repeat;
          background-size: 100% 100%;
        }
      }
      .wrap-content {
        width: 95%;
        margin: auto;
        padding: 0.3rem;
        box-sizing: border-box;
        border: 0.01rem solid rgba(229, 229, 229, 1);
        border-radius: 0.15rem;
      }
      .list-title {
        font-size: 0.26rem;
        color: #000000;
        border-bottom: 0.01rem solid rgba(229, 229, 229, 1);
        line-height: 0.83rem;
        padding: 0rem 0.32rem;
        box-sizing: border-box;
      }
      .item {
        font-size: 0.26rem;
        color: #535353;
        border-bottom: 0.01rem solid rgba(229, 229, 229, 1);
        line-height: 0.83rem;
        padding: 0rem 0.32rem;
        box-sizing: border-box;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        padding-right: 1rem;
        position: relative;
      }
      .itemBnt {
        position: absolute;
        top: 0px;
        bottom: 0px;

        margin: auto;
        right: 0.1rem;
        float: right;
        font-size: 0.24rem;
        color: #fff;
        background: #f5b53a;
        height: 0.34rem;
        line-height: 0.34rem;
        padding: 0rem 0.05rem;
        border-radius: 0.05rem;
      }
      .sure {
        font-size: 0.32rem;
        color: #fff;
        background: #05a2ff;
        width: 3.2rem;
        margin: auto;
        line-height: 0.8rem;
        text-align: center;
        border-radius: 0.15rem;
        margin-top: 0.35rem;
      }
    }
  }
  .noData {
    width: 3rem;
    margin: auto;
    padding-top: 3rem;
    font-size: 0.32rem;
    text-align: center;
    img {
      width: 100%;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/me/answer.vue